import React, { useState } from "react";
import { IonIcon, IonItem, IonLabel } from "@ionic/react";
import { idCardOutline } from "ionicons/icons";
import EmployeeContactCard from "./EmployeeContactCard";

interface EmployeeContactFieldProps {
  label?: string;
  valueText: string;
  employeeId: string;
}

/**
 * A Work Order Details field whose value is an employee. The row is a single
 * tap target that opens the employee contact card (photo + email + phone with
 * call/text/email actions). Only rendered for roles that are assigned (have a
 * value), so no affordance is shown for unassigned roles (FR-1.2).
 */
const EmployeeContactField: React.FC<EmployeeContactFieldProps> = ({
  label,
  valueText,
  employeeId,
}) => {
  const [cardOpen, setCardOpen] = useState(false);

  return (
    <>
      <IonItem button detail={false} onClick={() => setCardOpen(true)}>
        <IonLabel>
          <p>{label}</p>
          <h3>{valueText}</h3>
        </IonLabel>
        <IonIcon slot="end" icon={idCardOutline} color="primary" />
      </IonItem>
      <EmployeeContactCard
        isOpen={cardOpen}
        employeeId={employeeId}
        displayName={valueText}
        role={label}
        onClose={() => setCardOpen(false)}
      />
    </>
  );
};

export default EmployeeContactField;
